exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img {\n\tdisplay: block;\n\tmargin-left: auto;\n\tmargin-right: auto;\n}\n\np {\n\ttext-align: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/MembriPay/src/app/components/not-found/not-found.component.css
// module id = ../../../../../src/app/components/not-found/not-found.component.css
// module chunks = main